<script lang="ts" setup>
defineProps<{
  title: string;
}>();
</script>

<template>
  <div class="section-header">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="mb-2">{{ title }}</h2>
      <div class="d-flex gap-2">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>